import posthog from "posthog-js";
import { unsubscribeToNotification } from "./unsubscribeToNotification";
import type { PushPreferences } from "@/components/Modals/NotificationModal";

const preferences: PushPreferences[] = ["Daily", "Weekly", "Only about free money", "Never"];

export function subscribeToNotification(topic: string) {
    for (const preference of preferences) {
      if (preference === topic) {
        continue;
      }
      unsubscribeToNotification(preference);
    }

    unsubscribeToNotification("daily_promos");
    (window.webkit as any)?.messageHandlers?.subscribeToNotifications?.postMessage(topic, (_: any, error: any) => {
        posthog.capture(`subscribed_to_${topic}_notification`, {
          success: !error,
          topic,
          error: error ? error : undefined
        });
      });
}